import React from "react"
import {
    getAntworttyp,
    getOptions,
} from "../../../anwendungskonfigurator/misc/widget-functions"
import {styled, Box, Typography} from "@mui/material"
import PropTypes from "prop-types"
import _ from "lodash"
import moment from "moment"

const setFractionDigits = (value) => ({
    minimumFractionDigits: value,
    maximumFractionDigits: value,
})

const BoxWithUnderline = styled(Box)(() => ({
    borderBottom: '1px solid #CDD5F4',
}))

const Label = styled(Typography)(() => ({
    fontWeight: 600,
    fontSize: "16px",
    lineHeight: "20px",
}))

const Value = styled(Typography)(() => ({
    fontWeight: 600,
    color: "#072ECA",
    fontSize: "18px",
    lineHeight: "22px",
    whiteSpace: "nowrap",
    marginLeft: "81px",
}))

const LabelValueTable = ({widget, value}) => {
    const {label, suffix = ""} = widget

    const options = getOptions(widget)
    const antworttyp = getAntworttyp(widget)
    let displayValue
    if (_.isBoolean(value)) {
        displayValue = value ? "Ja" : "Nein"
    } else if (options?.length) {
        displayValue = options?.find((option) =>
            _.isEqual(option.value, value),
        )?.[widget.subtext ? widget.subtext : "label"]
    } else if (antworttyp === "MONETARYAMOUNT") {
        const currencyFormated = typeof value === "number"
            ? (value?.toLocaleString("de-DE", {
                style: "currency",
                currency: "EUR",
            }))
            : "-"
        displayValue = suffix ? currencyFormated.replace("€", suffix) : currencyFormated

    } else if (antworttyp === "DATE") {
        displayValue = moment(value, "YYYY-MM-DD").format("DD.MM.YYYY")
    } else if (antworttyp === "PERCENTAGE") {
        displayValue =
            typeof value === "number"
                ? `${value?.toLocaleString("de-DE", setFractionDigits(2))} %`
                : "-"
    } else if (antworttyp === "PROMILLE") {
        displayValue =
            typeof value === "number"
                ? `${value?.toLocaleString("de-DE", setFractionDigits(4))} ‰`
                : "-"
    } else {
        displayValue = value
    }

    return (
        <BoxWithUnderline width="100%" py="8px" display="flex" justifyContent="space-between" alignItems="center">
            <Label>{label}</Label>
            <Value>{displayValue}</Value>
        </BoxWithUnderline>
    )
}

LabelValueTable.propTypes = {
    widget: PropTypes.object
}

export default LabelValueTable
